import { createReducer } from '@reduxjs/toolkit'

import { search, clearImages } from './actions'

const initialState = {
  images: [],
  totalImages: 0,
  isSearching: false,
  authorized: true,
  searchTerm: null,
  activeSearchRequestId: null,
}

function mergeUniqueImages(existingImages, nextImages) {
  const seenIds = new Set(existingImages.map((image) => image?.id))
  const dedupedNextImages = nextImages.filter((image) => {
    const imageId = image?.id

    if (!imageId || seenIds.has(imageId)) {
      return false
    }

    seenIds.add(imageId)
    return true
  })

  return [...existingImages, ...dedupedNextImages]
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(search.pending, (state, action) => {
      const page = action.meta?.arg?.page || 1
      const query = action.meta?.arg?.query

      if (page === 1) {
        state.searchTerm = query || state.searchTerm
        state.activeSearchRequestId =
          action.meta?.requestId || state.activeSearchRequestId
        state.images = []
        state.totalImages = 0
        state.isSearching = true
        return
      }

      if (
        state.searchTerm &&
        query &&
        state.searchTerm !== query
      ) {
        return
      }

      state.isSearching = true
    })
    .addCase(search.fulfilled, (state, action) => {
      const page = action.meta?.arg?.page || 1
      const query = action.meta?.arg?.query

      if (page === 1) {
        if (
          action.meta?.requestId &&
          state.activeSearchRequestId !== action.meta.requestId
        ) {
          return
        }

        if (action.payload !== undefined) {
          state.images = action.payload.photos || []
          state.totalImages = action.payload.total_results || 0
        }
        state.isSearching = false
        state.activeSearchRequestId = null
        return
      }

      if (state.searchTerm && query && state.searchTerm !== query) {
        return
      }

      if (action.payload !== undefined) {
        const previousImageCount = state.images.length
        const photos = action.payload.photos || []
        state.images = mergeUniqueImages(state.images, photos)
        state.totalImages =
          state.images.length > previousImageCount || previousImageCount === 0
            ? action.payload.total_results || 0
            : previousImageCount
      }
      state.isSearching = false
    })
    .addCase(search.rejected, (state, action) => {
      const page = action.meta?.arg?.page || 1
      const query = action.meta?.arg?.query

      if (page === 1) {
        if (
          action.meta?.requestId &&
          state.activeSearchRequestId !== action.meta.requestId
        ) {
          return
        }

        if (!state.images.length) {
          state.authorized = false
        } else {
          state.totalImages = state.images.length
        }
        state.isSearching = false
        state.activeSearchRequestId = null
        return
      }

      if (state.searchTerm && query && state.searchTerm !== query) return

      if (!state.images.length) {
        state.authorized = false
      } else {
        state.totalImages = state.images.length
      }
      state.isSearching = false
    })
    .addCase(clearImages, (state, action) => {
      state.images = []
      state.totalImages = 0
      state.isSearching = false
      state.searchTerm = null
      state.activeSearchRequestId = null
    })
    .addDefaultCase((state, action) => {})
})

export function selectImages(state) {
  return state.search.images
}

export function selectTotalImages(state) {
  return state.search.totalImages
}

export function selectIsSearching(state) {
  return state.search.isSearching
}

export function selectIsAuthorized(state) {
  return state.search.authorized
}
